import { AppName, type FindPageViewModel } from "src/http/types";
import { usePageModelData } from "src/shared/context/PageModelDataContext";

/*
 * WARNING - DO NOT MOVE THIS FILE
 * This file location is important to ensure our linting enforces we avoid unsafely accessing page model data
 * across different applications and shared components within this repo.
 */

/**
 * Returns the page model data specifically for the find page.
 */
export const useFindPageModelData = (): FindPageViewModel => {
  const data = usePageModelData();
  if (data.appName !== AppName.Find) {
    throw new Error("useFindPageModelData must be used on the find page only");
  }
  return data;
};
